import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import CheckoutSteps from './CheckoutSteps';
import { CheckoutAside, CheckoutMainTitle, CheckoutViewWrapper, CheckoutContent } from './CheckoutView.styled';
import CouponForm from './CouponForm';
import OrderSummaryCard from './OrderSummaryCard';

type Props = {};

export default function CheckoutView({}: Props) {
  const { t } = useTranslation('Checkout');

  return (
    <CheckoutViewWrapper>
      <Container>
        <Row>
          <Col col={12}>
            <CheckoutMainTitle>{t('checkout_title')}</CheckoutMainTitle>
          </Col>
          <Col col={12}>
            <CheckoutContent>
              <Row>
                <Col col={12} lg={8}>
                  <CheckoutSteps />
                </Col>
                <Col col={12} lg={4}>
                  <CheckoutAside>
                    <CouponForm />
                    <OrderSummaryCard />
                  </CheckoutAside>
                </Col>
              </Row>
            </CheckoutContent>
          </Col>
        </Row>
      </Container>
    </CheckoutViewWrapper>
  );
}
